<template>
	<div id="content_body">
		redirection
	</div>

</template>
<script>
	
	export default {
		name: 'prodOrderItem',
		props: {
			itemId: {
				type: Number,
				default: NaN,
				required: false
			}
		},
		async mounted () {
			if(this.$store.getters.loggedIn) {
				if(this.itemId && !isNaN(this.itemId)){
					await this.$store.dispatch('axiosGet', {
						domain: 'prodorderitem',
						id: this.itemId
					})
					.then(response => {
						if(response.data && response.data.prodOrderId)
							this.$router.push({ name: 'prodordershow', params: { itemId: response.data.prodOrderId } })
					})
					.catch(error => {
						console.log('error catch get prodorderitem by itemId == ', error.message)
					})
				}
			}
		},
		
	}

</script>